import { useRef } from 'react';
import { useSelector } from 'react-redux';
import { BsCalendarWeekFill } from 'react-icons/bs';
import PropTypes from 'prop-types';
import { formatDate } from 'lib';
import { dateFormatStr } from '../../constants';

const BookingCalendarLite = ({ onClick, datesOptions }) => {
    const userCountryCode =
        useSelector((state) => state.user?.language) || 'en-US';

    const tempCheckInDate = datesOptions?.checkin;
    const tempCheckOutDate = datesOptions?.checkout;

    const bookingCalendarRef = useRef(null);

    if (!tempCheckInDate || !tempCheckOutDate) {
        return null;
    }

    return (
        <div className="ab-dates-container" ref={bookingCalendarRef}>
            <div className="ab-dates-inner" onClick={onClick}>
                <div className="ab-filter">
                    <div className="ab-filter-group">
                        <div className="ab-input ab-checkin-container">
                            <span
                                className="ab-date"
                                role="button"
                                tabIndex="0"
                            >
                                <span className="ab-prefixIcon">
                                    <BsCalendarWeekFill size={17} />
                                </span>
                                <span className="ab-value">
                                    {formatDate(
                                        new Date(tempCheckInDate),
                                        dateFormatStr,
                                        userCountryCode
                                    )}
                                </span>
                            </span>
                        </div>

                        <div className="ab-dateSeparator"></div>

                        <div className="ab-input ab-checkout-container">
                            <span
                                className="ab-date"
                                role="button"
                                tabIndex="0"
                            >
                                <span className="ab-prefixIcon">
                                    <BsCalendarWeekFill size={17} />
                                </span>
                                <span className="ab-value">
                                    {formatDate(
                                        new Date(tempCheckOutDate),
                                        dateFormatStr,
                                        userCountryCode
                                    )}
                                </span>
                            </span>
                        </div>
                    </div>
                </div>
            </div>

            <div className="ab-popup" id="ab-calendar-dropdown">
                <div className="ab-calendar-dropdown-wrapper"></div>
            </div>
        </div>
    );
};

BookingCalendarLite.propTypes = {
    onClick: PropTypes.func,
    datesOptions: PropTypes.object,
};

export default BookingCalendarLite;
